import React from 'react';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_BOOK } from '@monorepo/shared/src/themes/defaultTheme';

type CommonFormInput = {
  label?: string;
  value?: string;
  placeholder?: string;
  onChange?: (event: any) => void;
  className?: string;
};

const CommonFormInput: React.FC<CommonFormInput> = ({
  label,
  value,
  onChange,
  className,
  placeholder = '',
}) => {
  const classes = useStyles();
  return (
    <Box className={className}>
      {label && <label className={classes.label}>{label}</label>}
      <Box component="form" className={classes.form}>
        <InputBase
          className={classes.input}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: any) => ({
  form: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  label: {
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(20),
    fontFamily: FONT_GSS_FUTURA_BOOK,
  },
  input: {
    flex: 1,
    '& input': {
      borderRadius: '8px',
      paddingLeft: '12px',
      border: 'solid 3px black',
      opacity: 1,
      boxSizing: 'border-box',
      height: theme.typography.pxToRem(48),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      fontFamily: FONT_GSS_FUTURA_BOOK,
      color: theme.palette.grey.main,
    },
    '& input:focus': {
      boxShadow: 'none !important',
      borderColor: theme.palette.primary.main,
    },
  },
}));

export default CommonFormInput;
